import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceMedia {
    lookupService = new APIServiceLookUp();

    async getAllClient(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}client/getAllClient`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async setClient(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}client/setClient`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateClient(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}client/updateClient`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async delClient(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}client/delClient`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getFooterImage(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}media/getFooterImage`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateFooterImage(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}media/updateFooterImage`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getAllMedia(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}media/getAllMedia`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async setMedia(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}media/setMedia`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateMedia(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}media/updateMedia`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async delMedia(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}media/delMedia`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getAllPDFs(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}pdf/getAllPDFs`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async setPDF(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}pdf/setPDF`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async delPDF(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}pdf/delPDF`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

}